// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","715":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"231":"2373b8b33ebf15406d85","715":"56837d47bd85949b0b38"}[chunkId] + ".js";
};